const translation = {
  name: '训练名称',
  title: '模型训练',
  trainDescription: '模型详情',
  createTask: '创建模型训练任务',
  gpuNum: 'GPU数量',
  modelName: '模型名称',
  baseModel: '基础模型',
  dataset: '数据源',
  config: '训练参数',
  newTask: {
    startToCreate: '创建一个新的模型训练任务',
  },
  task: {
    title: '训练任务',
    edit: '编辑训练任务',
    create: '创建训练任务',
  },
  template: {
    title: '训练模板',
    create: {
      title: '创建训练模板',
    },
    tab: {
      detail: '详情',
      cronjobs: '调度历史',
      manualjobs: '手动执行历史',
    },
    detail: {
      title: '训练模板详情',
    },
  },
  tasks: {
    detail: '详情',
    log: '日志',
    event: '事件',
    monitor: '监控',
    pod: '容器',
  },
  taskList: {
    idAndName: '名称 / ID',
    status: '状态',
    permission: '权限',
    model: '训练框架',
    modelName: '模型名称',
    dataset: '数据集',
    resourceInfo: '资源信息',
    config: '训练参数',
    crontab: '定时调度',
    lastRunAt: '上次执行时间',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    operations: '操作',
    createTrain: '创建训练',
    edit: '编辑',
    delete: '删除',
    start: '启动',
    stop: '停止',
    log: '日志',
    copy: '拷贝',
    more: '更多',
    create: '创建',
    searchPlaceholder: '搜索',
    view: '查看',
    createTask: '创建任务',
    createTemplate: '创建模板',
    editTask: '编辑任务',
    editTemplate: '编辑模板',
    deleteTask: '删除任务',
    deleteTemplate: '删除模板',
    startTask: '启动任务',
    stopTask: '停止任务',
    logTask: '日志任务',
    copyTask: '拷贝任务',
    moreTask: '更多任务',
    moreTemplate: '更多模板',
    baseModelPath: '基础模型路径',
    dataPath: '训练数据路径',
    outputDir: '输出模型路径',
    baseModelId: '基础模型ID',
    baseModelName: '基础模型名称',
    datasetId: '数据集ID',
    unknown: '未知',
  },
  resourceSelector: {
    billingMode: '计费方式',
    payg: '按量计费',
    reservedDay: '包日',
    reservedWeek: '包周',
    availableRegions: '可用地区',
    resourceCluster: '资源集群',
    resourceQueue: '资源队列',
    resourceGpu: 'GPU 型号',
    numGpu: 'GPU 数量',
    resourceSpec: '资源规格',
    instanceCount: '实例数量',
    resourceRequired: '资源不能为空',
    billingModeRequired: '计费方式不能为空',
    regionRequired: '地区不能为空',
    clusterRequired: '资源集群不能为空',
    queueRequired: '资源队列不能为空',
    specRequired: '资源规格不能为空',
    instanceCountRequired: '实例数量不能为空',
    unitHour: '元/小时'
  },
  // TrainingTaskForm 组件词条
  form: {
    name: '名称',
    permission: '权限',
    description: '描述',
    resource: '训练资源',
    framework: '训练框架',
    environment: '设置镜像',
    baseModel: '基础模型',
    modelVersion: '模型版本',
    trainingData: '训练数据',
    datasetVersion: '数据集版本',
    volumeMounts: '挂载存储',
    workingDir: '工作目录',
    cmd: '启动命令',
    args: '启动参数',
    env: '环境变量',
    restartPolicy: '重启策略',
    restartCount: '重启次数',
    outputModel: '输出模型',
    outputModelName: '输出模型名称',
    modelPath: '模型路径',
    confirm: '确定',
    cancel: '取消',
    saveTemplate: '另存为模板',
    templateName: '模板名称',
    templateNameRequired: '模板名称不能为空',
    // 动态文案
    resourceName: '资源名称',
    resourcePermission: '资源权限',
    resourceDescription: '资源描述',
    resourcePermissionRequired: '资源权限不能为空',
    // 重启策略选项
    never: '不重启',
    onFailure: '失败重启',
    always: '总是重启',
    // 存储类型
    diskStorage: '磁盘存储',
    s3Storage: 'S3存储',
    // 提示文案
    permissionTooltip: '设置训练任务的访问权限：私有仅自己可见，公开则项目内所有成员可见',
    descriptionTooltip: '对训练任务的简要描述，便于后续识别和管理',
    resourceTooltip: '选择训练任务运行所需的计算资源，包括GPU型号、数量和实例规格',
    frameworkTooltip: '选择训练使用的深度学习框架，如PyTorch、TensorFlow等',
    environmentTooltip: '选择训练任务运行的容器镜像，镜像中应包含训练框架和所需依赖环境',
    baseModelTooltip: '选择用于微调或继续训练的基础预训练模型',
    modelVersionTooltip: '选择基础模型的具体版本',
    trainingDataTooltip: '选择用于训练的数据集，数据集将被挂载到容器中',
    datasetVersionTooltip: '选择数据集的具体版本',
    volumeMountsTooltip: '将存储磁盘、模型或数据集挂载到容器指定路径，用于数据读取和持久化存储',
    workingDirTooltip: '容器启动时的工作目录路径，启动命令将在此目录下执行',
    cmdTooltipIntro:
      '系统环境变量以及自定义启动参数，通过"{{变量名称}}"方式进行引用。',
    cmdTooltipSystemVars: '系统环境变量如下：',
    argsTooltip: '自定义启动参数，可以在启动变量中进行引用',
    envTooltip: '设置容器运行时的环境变量，可用于配置训练任务的超参数和运行参数',
    restartPolicyTooltip: '设置训练任务失败时的重启策略：不重启、失败时重启或总是重启',
    outputModelTooltip: '训练完成后输出模型的保存位置和名称',
    crontabTooltip: '设置定时调度规则，按指定时间周期自动执行训练任务',
    datasetName: '数据集名称',
    trainId: '训练任务ID',
    trainName: '训练任务名称',
    outputModelStorageRequired: '输出模型存储不能为空',
    outputModelNamePlaceholder: '输出模型名称',
    s3PathPlaceholder: 's3://bucket-name/path',
    diskModelPath: '模型路径：「存储磁盘根目录」/models/{{modelName}}',
    s3ModelPath: '模型路径：{{s3Path}}/{{modelName}}',
    // 验证消息
    frameworkRequired: '训练框架不能为空',
    environmentRequired: '训练环境不能为空',
    baseModelRequired: '基础模型不能为空',
    restartPolicyRequired: '重启策略不能为空',
    restartCountRequired: '重启次数不能为空',
    // 操作文案
    updateTrainingTask: '更新训练任务',
    createTrainingTask: '创建训练任务',
    saveAsTemplate: '保存为模板',
    inputTemplateName: '请输入模板名称',
    // 费用相关
    totalCost: '总费用',
    perHour: '/小时',
  },
  edit: {
    title: '编辑训练模板',
  },
  model: {
    title: '模型管理',
    create: {
      title: '创建模型',
    },
    edit: {
      title: '编辑模型',
    },
    detail: {
      title: '模型详情',
    },
    versions: {
      title: '模型版本',
    },
    tab: {
      detail: '详情',
      versions: '版本',
      files: '文件',
    },
  },
}

export default translation
